<template>
  <div>
    <b-container>
      <sample v-if="true" />
      <h3 v-else>
        Thanks for signing in and feeling out our form. We are processing your
        submission
      </h3>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Sample from "@/components/forms/sample";

export default {
  name: "Display_Survey",
  components: {
    Sample
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    })
  },
  data() {
    return {
      loading: false,
      completed: false
    };
  },
  methods: {}
};
</script>

<style lang="css" scoped></style>
